import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dynamic-html-modal',
  templateUrl: './dynamic-html-modal.html',
  styleUrls: ['./dynamic-html-modal.scss'],
})
export class DynamicHtmlModal implements OnInit {
  @Input() title?: string;
  @Input() htmlContent: string;
  safeHtmlContent: string = '';


  constructor(
    private modalController: ModalController,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.safeHtmlContent =
      this.sanitizer.sanitize(SecurityContext.HTML, this.htmlContent || '') ||
      '';
  }

  closeModal() {
    this.modalController.dismiss();
  }
}